import IntegradoresService from './../_services/IntegradoresService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import {Integrador} from '../_models/IntegradorModel'

const state = {
  loading: false,
  loadingStore: false,
  dropDownIntegradores: [],
  integradores: [],
  integradorSelecionado: undefined,
  erros: '',
}

const getters = {
  GET_INTEGRADORES : (state) => state.integradores,
  GET_DROPDOWN: state => state.dropDownIntegradores,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  INTEGRADOR_SELECTED : (state, { integrador }) => {
    state.integradorSelecionado = Object.assign({}, integrador)
  },

  SET_INTEGRADORES : (state, { integradores }) => {
    state.integradores = integradores
  },

  SET_DROPDOWN : (state, integradores) => {
    state.dropDownIntegradores = integradores
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.integradorSelecionado = undefined,

}

const actions = {

  LOAD_DROPDOWN : async ({commit}, id) => {
    commit('SET_DROPDOWN', [])
    commit('ERASE_ERROS')
    if (!id) id=0
    await IntegradoresService.getDropDown(id)
    .then(response => {
      if (response.data.status) {
        var obj = response.data.integrador
        commit('SET_DROPDOWN', obj)

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })
  },

  GET_INTEGRADORES : async ({ commit }) => {
      commit('SET_INTEGRADORES', { integradores : []})
      commit('ERASE_ERROS')
      await IntegradoresService.getIntegradores()
      .then(response => {
        if (response.data.status) {
          commit('SET_INTEGRADORES', { integradores : response.data.integrador })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      })
  },

  GET_INTEGRADOR : async ({commit}, id) => {
    return new Promise(async (resolve, reject) => {
      commit('ERASE_ERROS')
      await IntegradoresService.getIntegrador(id)
      .then(response => {
        if (response.data.status) {
          commit('INTEGRADOR_SELECTED', { integrador : response.data.integrador })
          resolve(response.data.integrador)
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
          reject(response.data.erro)
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      })
    })

  },

  STORE_INTEGRADOR : async ({ commit, dispatch }, integrador) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!integrador.id || !(integrador.id > 0)) { 
        var response = await IntegradoresService.postIntegrador(integrador)
      } else {
        var response = await IntegradoresService.putIntegrador(integrador.id, integrador)
      }

      if (response.data.status) {
        commit('INTEGRADOR_SELECTED', { integrador : response.data.integrador })
        dispatch('GET_INTEGRADORES')
        //await dispatch('GET_INTEGRADOR', response.data.categoria.id)

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_INTEGRADOR : async ({ commit, dispatch }, integrador) => {
    commit('ERASE_ERROS')
    try {
      var response = await IntegradoresService.deleteIntegrador(integrador.id)

      if (response.data.status) {
        await dispatch('GET_INTEGRADORES')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  INTEGRADOR_SELECTED : async ({dispatch, commit}, id) => {
    if (id > 0) { 
      await dispatch('GET_INTEGRADOR', id)
    } else {
      var obj = new Integrador();
      await commit('INTEGRADOR_SELECTED', { integrador: obj })
    }    
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/IntegradoresApi/_store/index.js